import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { DocumentsParams } from '@app/services/document.service';

@Component({
    selector: 'tt-documents-view',
    templateUrl: './documents-view.component.html',
    styleUrls: ['./documents-view.component.css'],
})
export class DocumentsViewComponent {
    public params: DocumentsParams;

    public heading = '';

    constructor(state: StateService) {
        this.params = state.getStateParams() as unknown as DocumentsParams;
    }
}
